module.exports = __webpack_public_path__ + "img/img-shibai.adc75069.jpg";